import React, { useState } from "react";
import "./styles.css";
import Preview from "./components/Preview";
import { Form, FormGroup, Label, Input, Button } from "reactstrap";
import { Container } from "reactstrap";
import { BsPencilSquare } from "react-icons/bs";
import inputData from "./inputData";

function App() {
  const defaultSettings = {
    dataset: Object.keys(inputData)[0],
    additionalGuideline: true,
    trailCharacters: true,
    randomizeOrder: false,
  };

  const [settings, setSettings] = useState(defaultSettings);

  return (
    <Container fluid="xl">
      <div className="d-print-none">
        <p className="display-2 py-3 text-dark text text-center">
          <BsPencilSquare />
          printouts
        </p>

        <Form className="p-3 shadow border border-success rounded-lg mb-4 bg-light">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <FormGroup className="mb-0 flex-grow-1 mr-3">
              <Input
                type="select"
                value={settings.dataset}
                onChange={(e) => {
                  e.persist();
                  setSettings((old) => ({ ...old, dataset: e.target.value }));
                }}
              >
                {Object.keys(inputData).map((key) => (
                  <option key={key} value={key}>
                    {inputData[key].name}
                  </option>
                ))}
              </Input>
            </FormGroup>
            <Button className="float-right" color="success" onClick={() => window.print()}>
              Print or Download
            </Button>
          </div>

          <div className="d-flex align-items-center flex-wrap">
            <FormGroup check className="mx-2">
              <Label check>
                <Input
                  type="checkbox"
                  checked={settings.additionalGuideline}
                  onChange={() => setSettings((old) => ({ ...old, additionalGuideline: !old.additionalGuideline }))}
                />
                Additional guideline
              </Label>
            </FormGroup>

            <FormGroup check className="mx-2">
              <Label check>
                <Input
                  type="checkbox"
                  checked={settings.trailCharacters}
                  onChange={() => setSettings((old) => ({ ...old, trailCharacters: !old.trailCharacters }))}
                />
                Trail characters
              </Label>
            </FormGroup>

            <FormGroup check className="mx-2">
              <Label check>
                <Input
                  type="checkbox"
                  checked={settings.randomizeOrder}
                  onChange={() => setSettings((old) => ({ ...old, randomizeOrder: !old.randomizeOrder }))}
                />
                Randomize order
              </Label>
            </FormGroup>
          </div>
        </Form>
      </div>

      <Preview {...settings} className="mx-auto" />
    </Container>
  );
}

export default App;
